// @ts-strict

import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ITrafficSourceDomain } from '@services/traffic-sources/traffic-sources.types';

@Injectable({
  providedIn: 'root'
})
export class TrafficSourceManagementService {
  public campaignName = new BehaviorSubject<string>('');
  public campaignId = new BehaviorSubject<number | null>(null);
  public isNewTrafficSourceAdded = new BehaviorSubject<boolean>(false);
  public traficSourceToRemove = new Subject<ITrafficSourceDomain>();

  public domains = new BehaviorSubject<ITrafficSourceDomain[]>([]);

  public trafficSources = new BehaviorSubject<ITrafficSourceDomain[]>([]);

  public saveData(trafficSources: ITrafficSourceDomain[]): void {
    this.trafficSources.next(trafficSources);
  }

  public shareNewTrafficSourceStatus(status: boolean): void {
    this.isNewTrafficSourceAdded.next(status);
  }

  public setDomains(domain: ITrafficSourceDomain[]): void {
    const newDomains = [...domain];
    this.domains.next(newDomains);
  }

  public setCampaignName(name: string): void {
    this.campaignName.next(name);
  }

  public setCampaignId(id: number | null): void {
    this.campaignId.next(id);
  }

  public clearValues(): void {
    this.campaignId.next(null);
    this.campaignName.next('');
    this.domains.next([]);
    this.trafficSources.next([]);
  }

  public removeTrafficSource(trafficSource: ITrafficSourceDomain): void {
    this.traficSourceToRemove.next(trafficSource);
  }
}
